var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 12.2457V14.6101C-0.000244141 14.8279 0.170867 14.999 0.388645 14.999H2.75309C2.8542 14.999 2.95531 14.9601 3.02531 14.8823L11.5186 6.39679L8.60198 3.48013L0.116423 11.9657C0.0386448 12.0435 -0.000244141 12.1368 -0.000244141 12.2457ZM13.7742 4.14124C14.0775 3.8379 14.0775 3.3479 13.7742 3.04457L11.9542 1.22457C11.6509 0.921237 11.1609 0.921237 10.8575 1.22457L9.4342 2.6479L12.3509 5.56457L13.7742 4.14124Z",
    fill: "#2F696D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconSelected);
export default __webpack_public_path__ + "static/media/EditIconSelected.e86fc4d284e0a02d8e14bc349d7161e5.svg";
export { ForwardRef as ReactComponent };